import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, Transition as _Transition, withCtx as _withCtx, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '@/assets/img/case/banner.png';
import _imports_1 from '@/assets/img/case/banner_h5.png';
import _imports_2 from '@/assets/img/case/bg.png';
import _imports_3 from '@/assets/img/case/bg_h5.png';
import _imports_4 from '@/assets/img/home/up_arrow.png';
import _imports_5 from '@/assets/img/home/down_arrow.png';
import _imports_6 from '@/assets/img/about/hzqy.jpg';
const _withScopeId = n => (_pushScopeId("data-v-6e3a2fce"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "case"
};
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<div class=\"banner_box\" data-v-6e3a2fce><img class=\"hidden-xs-only banner\" src=\"" + _imports_0 + "\" alt=\"\" data-v-6e3a2fce><img class=\"hidden-sm-and-up banner\" src=\"" + _imports_1 + "\" alt=\"\" data-v-6e3a2fce><div class=\"content hidden-xs-only\" data-v-6e3a2fce><div class=\"title\" data-v-6e3a2fce>全域智慧营销领航者</div><div class=\"tip\" data-v-6e3a2fce>解决精准获客 高效转化</div><div class=\"en\" data-v-6e3a2fce> Solve accurate customer acquisition and efficient transformation </div><div class=\"info\" data-v-6e3a2fce><span data-v-6e3a2fce>赋能足迹遍布全国</span><div class=\"num\" data-v-6e3a2fce>25+</div><span data-v-6e3a2fce>个省，</span><div class=\"num\" data-v-6e3a2fce>300+</div><span data-v-6e3a2fce>座城市，服务品牌超</span><div class=\"num\" data-v-6e3a2fce>1000+</div><span data-v-6e3a2fce>个！到访效率提升</span><div class=\"num\" data-v-6e3a2fce>10</div><span data-v-6e3a2fce>倍起、获客提升</span><div class=\"num\" data-v-6e3a2fce>3</div><span data-v-6e3a2fce>倍起！</span></div></div></div>", 1);
const _hoisted_3 = {
  class: "cases"
};
const _hoisted_4 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "top"
}, [/*#__PURE__*/_createElementVNode("div", {
  class: "title"
}, "客户成功案例")], -1));
const _hoisted_5 = {
  class: "box hidden-xs-only"
};
const _hoisted_6 = {
  class: "left-out"
};
const _hoisted_7 = {
  class: "left"
};
const _hoisted_8 = ["onClick"];
const _hoisted_9 = {
  class: "title"
};
const _hoisted_10 = {
  class: "info"
};
const _hoisted_11 = ["src"];
const _hoisted_12 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "bg",
  src: _imports_2,
  alt: ""
}, null, -1));
const _hoisted_13 = ["src"];
const _hoisted_14 = {
  class: "list-out hidden-sm-and-up"
};
const _hoisted_15 = {
  class: "list"
};
const _hoisted_16 = ["onClick"];
const _hoisted_17 = {
  class: "title"
};
const _hoisted_18 = {
  class: "info"
};
const _hoisted_19 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "bg",
  src: _imports_3,
  alt: ""
}, null, -1));
const _hoisted_20 = ["src"];
const _hoisted_21 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "arrow",
  src: _imports_4,
  alt: ""
}, null, -1));
const _hoisted_22 = {
  key: 1,
  class: "arrow",
  src: _imports_5,
  alt: ""
};
const _hoisted_23 = ["src"];
const _hoisted_24 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "text-intro hzqj"
}, [/*#__PURE__*/_createElementVNode("img", {
  src: _imports_6
})], -1));
import { onMounted, onUnmounted, reactive, ref } from "vue";
const __default__ = {
  metaInfo: {
    title: "客户及案例-京奇数据智慧营销",
    meta: [{
      name: "description",
      content: "四川京奇数据科技有限公司凭借其在大数据科技领域的深厚积累和创新业务模式，为众多知名企业和项目提供了全方位的解决方案。从房产智悦拎包到京小电智慧节能，再到京东服务+推广，我们的客户案例涵盖了房地产、家居、节能等多个领域。通过成功合作，我们帮助客户实现了市场竞争力的提升、运营成本的降低以及用户体验的优化。浏览我们的客户案例，了解我们如何为不同行业创造价值。"
    }, {
      name: "keywords",
      content: "四川京奇数据科技、客户案例、成功案例、房产智悦拎包案例、京小电节能案例、京东服务+推广案例、房地产营销案例、智能家居解决方案、智慧节能项目、客户合作、项目案例、大数据科技应用"
    }],
    link: [{
      rel: "",
      href: ""
    }]
  }
};
export default /*#__PURE__*/_defineComponent({
  ...__default__,
  __name: 'Case',
  setup(__props) {
    const files = require.context("@/assets/img/home/collection", false, /\.png$/);
    const imgs = files.keys().sort((a, b) => +a.replace('./', '').replace('.png', '') - +b.replace('./', '').replace('.png', '')).map(key => files(key));
    const cases = reactive([{
      title: "#首月突破195套#",
      info: "河南西平 御都集团",
      logo: require("@/assets/img/case/logo1.png"),
      img: require("@/assets/img/case/case1.png")
    }, {
      title: "#月销量增长50+套#",
      info: "步步高东方香溪湾",
      logo: require("@/assets/img/case/logo1.png"),
      img: require("@/assets/img/case/case2.png")
    }, {
      title: "#单日突破81套#",
      info: "河北文安智慧新城",
      logo: require("@/assets/img/case/logo3.png"),
      img: require("@/assets/img/case/case3.png")
    }, {
      title: "#销量增长1亿+#",
      info: "四川富临锦悦府",
      logo: require("@/assets/img/case/logo4.png"),
      img: require("@/assets/img/case/case4.png")
    }, {
      title: "#月均销量100套#",
      info: "华泰集团三盘联动",
      logo: require("@/assets/img/case/logo5.png"),
      img: require("@/assets/img/case/case5.png")
    }, {
      title: "#成就区域销冠#",
      info: "旭辉理想城",
      logo: require("@/assets/img/case/logo6.png"),
      img: require("@/assets/img/case/case6.png")
    }]);
    const active = ref(0);
    const timer = ref();
    const per = ref(0);
    const stop = () => {
      clearInterval(timer.value);
    };
    const continueFunc = () => {
      clearInterval(timer.value);
      timer.value = setInterval(() => {
        if (per.value >= 100) {
          clearInterval(timer.value);
          setTimeout(() => {
            handleClick(active.value + 1 > 5 ? 0 : active.value + 1);
          }, 500);
          return;
        }
        per.value += 1;
      }, 100);
    };
    const init = () => {
      per.value = 0;
      continueFunc();
    };
    const handleClick = i => {
      active.value = i;
      init();
    };
    const handleTap = i => active.value = i;
    onMounted(() => {
      if (globalThis.matchMedia("(max-width: 767px)").matches) return;
      init();
    });
    onUnmounted(() => clearInterval(timer.value));
    return (_ctx, _cache) => {
      const _component_el_progress = _resolveComponent("el-progress");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_hoisted_2, _createElementVNode("div", _hoisted_3, [_hoisted_4, _createElementVNode("div", _hoisted_5, [_createElementVNode("div", _hoisted_6, [_createElementVNode("div", _hoisted_7, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(cases, (item, i) => {
        return _openBlock(), _createElementBlock("div", {
          class: _normalizeClass(['card', active.value === i ? 'active' : '']),
          key: i,
          onClick: $event => handleClick(i)
        }, [_createElementVNode("div", _hoisted_9, _toDisplayString(item.title), 1), _createElementVNode("div", _hoisted_10, _toDisplayString(item.info), 1), active.value === i ? (_openBlock(), _createElementBlock(_Fragment, {
          key: 0
        }, [_createElementVNode("img", {
          class: "logo",
          src: item.logo,
          alt: ""
        }, null, 8, _hoisted_11), _hoisted_12, _createVNode(_component_el_progress, {
          class: "progress",
          percentage: per.value,
          "show-text": false,
          "stroke-width": 4
        }, null, 8, ["percentage"])], 64)) : _createCommentVNode("", true)], 10, _hoisted_8);
      }), 128))])]), _createElementVNode("div", {
        class: "right",
        onMouseenter: stop,
        onMouseleave: continueFunc
      }, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(cases, (item, i) => {
        return _openBlock(), _createElementBlock("div", {
          key: i
        }, [_createVNode(_Transition, {
          name: "slide",
          "enter-active-class": "animate__animated animate__fadeIn"
        }, {
          default: _withCtx(() => [active.value === i ? (_openBlock(), _createElementBlock("img", {
            key: 0,
            class: "case_img",
            src: item.img,
            alt: ""
          }, null, 8, _hoisted_13)) : _createCommentVNode("", true)]),
          _: 2
        }, 1024)]);
      }), 128))], 32)]), _createElementVNode("div", _hoisted_14, [_createElementVNode("div", _hoisted_15, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(cases, (item, i) => {
        return _openBlock(), _createElementBlock("div", {
          key: i,
          onClick: $event => handleTap(i)
        }, [_createElementVNode("div", {
          class: _normalizeClass(['card', active.value === i ? 'active' : ''])
        }, [_createElementVNode("div", _hoisted_17, _toDisplayString(item.title), 1), _createElementVNode("div", _hoisted_18, _toDisplayString(item.info), 1), active.value === i ? (_openBlock(), _createElementBlock(_Fragment, {
          key: 0
        }, [_hoisted_19, _createElementVNode("img", {
          class: "logo",
          src: item.logo,
          alt: ""
        }, null, 8, _hoisted_20), _hoisted_21], 64)) : (_openBlock(), _createElementBlock("img", _hoisted_22))], 2), _createVNode(_Transition, {
          name: "slide",
          "enter-active-class": "animate__animated animate__fadeIn"
        }, {
          default: _withCtx(() => [active.value === i ? (_openBlock(), _createElementBlock("img", {
            key: 0,
            class: "case_img",
            src: item.img,
            alt: ""
          }, null, 8, _hoisted_23)) : _createCommentVNode("", true)]),
          _: 2
        }, 1024)], 8, _hoisted_16);
      }), 128))])])]), _hoisted_24]);
    };
  }
});